/* The Bean Archives V2 — interactions. Progressive enhancement; reduced-motion aware. */
(() => {
  "use strict";

  const nav = document.querySelector(".nav");
  if (nav) {
    const onScroll = () => nav.classList.toggle("is-stuck", window.scrollY > 8);
    onScroll();
    addEventListener("scroll", onScroll, { passive: true });
  }

  const burger = document.querySelector(".nav__burger");
  const scrim = document.querySelector(".scrim");
  const setMenu = (open) => {
    document.body.classList.toggle("menu-open", open);
    if (burger) burger.setAttribute("aria-expanded", String(open));
  };
  burger && burger.addEventListener("click", () =>
    setMenu(!document.body.classList.contains("menu-open")));
  scrim && scrim.addEventListener("click", () => setMenu(false));
  document.querySelectorAll(".drawer a").forEach((a) =>
    a.addEventListener("click", () => setMenu(false)));
  addEventListener("keydown", (e) => e.key === "Escape" && setMenu(false));

  const reduced = matchMedia("(prefers-reduced-motion: reduce)").matches;
  const reveals = document.querySelectorAll("[data-reveal]");
  if (reduced || !("IntersectionObserver" in window)) {
    reveals.forEach((el) => el.classList.add("is-in"));
  } else {
    const io = new IntersectionObserver((entries, obs) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        const el = entry.target;
        const sibs = [...(el.parentElement?.querySelectorAll(":scope > [data-reveal]") || [el])];
        const i = Math.max(0, sibs.indexOf(el));
        el.style.setProperty("--d", `${Math.min(i, 6) * 80}ms`);
        el.classList.add("is-in");
        obs.unobserve(el);
      });
    }, { rootMargin: "0px 0px -8% 0px", threshold: 0.12 });
    reveals.forEach((el) => io.observe(el));
  }

  /* clean / mixed / funky lean toggle — honest, brief-aligned copy */
  document.querySelectorAll("[data-lean]").forEach((group) => {
    const readout = group.parentElement.querySelector(".lean-readout");
    const buttons = group.querySelectorAll("button");
    const copy = {
      clean: 'Four that lean <b>clean</b> — washed, high-grown, tea-clear. Bright and precise, the easy yeses.',
      mixed: 'Two clean, two funky — the <b>whole spectrum</b> in four bags. The honest default if you can\'t choose.',
      funky: 'Four that lean <b>funky</b> — anaerobics, naturals, co-ferments. Loud, divisive, the fun risk.'
    };
    const select = (lean) => {
      buttons.forEach((b) => b.setAttribute("aria-pressed", String(b.dataset.lean === lean)));
      if (readout) readout.innerHTML = copy[lean];
    };
    buttons.forEach((b) => b.addEventListener("click", () => select(b.dataset.lean)));
    select(group.dataset.lean || "mixed");
  });

  document.querySelectorAll("[data-year]").forEach((el) => (el.textContent = "2026"));
})();

/* V5 — Spotify-Wrapped count-up numbers */
(function () {
  const els = document.querySelectorAll("[data-count]");
  if (!els.length) return;
  const reduced = matchMedia("(prefers-reduced-motion: reduce)").matches;
  if (reduced || !("IntersectionObserver" in window)) {
    els.forEach((el) => (el.textContent = el.dataset.count));
    return;
  }
  const run = (el) => {
    const target = +el.dataset.count, dur = 1500, t0 = performance.now();
    const tick = (now) => {
      const t = Math.min(1, (now - t0) / dur);
      const e = 1 - Math.pow(1 - t, 3);
      el.textContent = Math.round(e * target);
      if (t < 1) requestAnimationFrame(tick); else el.textContent = target;
    };
    requestAnimationFrame(tick);
  };
  const io = new IntersectionObserver((ents, obs) => {
    ents.forEach((en) => { if (en.isIntersecting) { run(en.target); obs.unobserve(en.target); } });
  }, { threshold: 0.4 });
  els.forEach((el) => io.observe(el));
})();

/* V7 — hero rotating word: "6X {Variety / Discovery / Taste / …}" cycling flavor gradients */
(function () {
  if (matchMedia("(prefers-reduced-motion: reduce)").matches) return;
  const words = ["Variety", "Discovery", "Taste", "Roasters", "Flavor", "Coffees", "Education"];
  const grads = ["--g-jam", "--g-sunset", "--g-berry", "--g-grape", "--g-mesh"];
  document.querySelectorAll("[data-rotor]").forEach((rotor, idx) => {
    const w = rotor.querySelector(".rotor__w");
    if (!w) return;
    let wi = idx % words.length, gi = idx % grads.length;
    setInterval(() => {
      w.classList.add("is-out");
      setTimeout(() => {
        wi = (wi + 1) % words.length;
        gi = (gi + 1) % grads.length;
        w.textContent = words[wi];
        w.style.backgroundImage = `var(${grads[gi]})`;
        w.classList.remove("is-out");
      }, 430);
    }, 2200);
  });
})();

/* Home — floating Subscribe button, revealed once the hero scrolls out of view */
(function () {
  const cta = document.querySelector("[data-home-cta]");
  const hero = document.querySelector(".hero");
  if (!cta || !hero || !("IntersectionObserver" in window)) return;
  const io = new IntersectionObserver(
    ([e]) => cta.classList.toggle("is-show", !e.isIntersecting),
    { rootMargin: "-40% 0px 0px 0px" }
  );
  io.observe(hero);
})();
